import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import withStyles from "components/with-styles";
import styles from "./styles/footer-wrapper.css.js";

const FooterWrapper = ({ className, classes, children, open }) => (
  <AppBar
    position="fixed"
    color="primary"
    className={cn(
      className,
      classes.dashboard_footer,
      classes.dashboard_navigationbar,
      open && classes.dashboard_navigationbar__shift,
      !open && classes.dashboard_footer__shift__closed,
    )}
  >
    <Toolbar className={classes.dashboard_footer_content}>{children}</Toolbar>
  </AppBar>
);

FooterWrapper.propTypes = {
  /**
   * Indica si el menú lateral del dashboard está desplegado
   **/
  open: PropTypes.bool,
  /**
   * Clase adicional del componente.
   */
  className: PropTypes.string,
};

export default withStyles(styles)(FooterWrapper);
